<template>
  <div>
    <div class="text-right">
      <el-button size="mini" type="success" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app-table"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :table-props="{'max-height': '450px'}"
      :get-data="getAssetsList()"
    />
  </div>
</template>

<script>
import EventManager from '@/api/tool/event-manager/jrtt';
const eventManager = new EventManager();

import { getWechatMiniGameApi, pullWechatMiniGameApi } from '@/api/tool/wechat-mini-game/jrtt';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    /** 广告主ID */
    advertiserId: {
      type: [String, Number],
      required: true,
    },
    /** 资产类型 */
    assetType: {
      type: String,
      default: '',
    },
    /** 推广目的 */
    landingType: {
      type: String,
      default: '',
    },
    /** 广告类型 */
    adType: {
      type: String,
      default: '',
    },
    /** 小游戏类型 */
    mgType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      table_params: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    /**
     * 获取小游戏资产列表
     * @param {Object} parmas 接口参数
     * @return {Function}
     */
    getAssetsList() {
      const strategy = {
        'WECHAT_GAME': (params) => this.getWechatGameList(params),
        'BYTE_GAME': (params) => this.getByteGameList(params),
      };
      return strategy[this.mgType];
    },
    /**
     * 同步资产列表
     * @returns {void}
     */
    onPull() {
      const strategy = {
        'WECHAT_GAME': this.pullWechatGameList,
        'BYTE_GAME': this.pullByteGameList,
      };
      strategy[this.mgType]().then(({ message }) => {
        this.$message.success(message || '同步成功');
        this.$refs['app-table'].seekTable();
      });
    },
    /**
     * 获取微信小游戏列表
     * @param {Object} params 接口参数
     * @return {Promise<Object>}
     */
    getWechatGameList(params) {
      return new Promise((resolve, reject) => {
        getWechatMiniGameApi({
          advertiser_id: this.advertiserId,
          ...params,
        }).then(res => {
          res.list = (res.list || []).map(({ id, name, user_name }) => ({ asset_name: name, micro_app_id: user_name, micro_app_instance_id: id }));
          resolve(res);
        }).catch(reject);
      });
    },
    /**
     * 获取字节小游戏列表
     * @param {Object} params 接口参数
     * @return {Promise<Object>}
     */
    getByteGameList(params) {
      return new Promise((resolve, reject) => {
        eventManager.getAssetsListApi({
          advertiser_id: this.advertiserId,
          asset_type: this.assetType,
          ...params,
        }).then(resolve).catch(reject);
      });
    },
    /**
     * 同步微信小游戏列表
     * @return {Promise<Object>}
     */
    pullWechatGameList() {
      return new Promise((resolve, reject) => {
        const params = {
          advertiser_id: this.advertiserId,
        };
        pullWechatMiniGameApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 同步字节小游戏列表
     * @return {Promise<Object>}
     */
    pullByteGameList() {
      return new Promise((resolve, reject) => {
        const params = {
          advertiser_id: this.advertiserId,
          asset_type: this.assetType,
          landing_type: this.landingType,
          ad_type: this.adType,
        };
        eventManager.pullEventAssetsApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 确认
     * @param {Object} row 资产数据
     */
    confirm(row) {
      this.$emit('confirm', row);
    },
  },
};
</script>
